export function accordion() {
    $(".accordion").click(function(event) {
        var slideBox = $(this).closest(".section-insights");
        slideBox.find(".accordion_box").not($(this).parent()).removeClass('active').find('.panel').slideUp('slow/400/fast');
        $(this).parent().toggleClass('active').find('.panel').slideToggle('slow/400/fast');


        if ($(this).parent().hasClass('active')) {
            var index = $(this).attr('data-index');

            var videoSrc = $(this).closest( ".section-insights" ).find(".insights-right .js-video-main").attr('data-video-' + index);
            if (videoSrc) {
                showVideo(videoSrc);
                return;
            }

            var imageSrc = $(this).closest( ".section-insights" ).find(".insights-right .js-small-main").attr('data-img-' + index);
            if (imageSrc) {
                showSmallImage(imageSrc);
                return;
            }

            var bImageSrc = $(this).closest( ".section-insights" ).find(".insights-right").attr('data-image-' + index);
            if (bImageSrc) {
                showBigImage(bImageSrc);
                return;
            }

        }

        hideAll();


        function showVideo (url) {
            $(slideBox).find(".insights-right .js-closed").css('display', 'none');
            $(slideBox).find(".insights-right").css('background-image', 'none');
            $(slideBox).find(".insights-right .js-small-main").css('display','none');

            $(slideBox).find(".insights-right .js-video-main source").each(function(){
                $(this).attr('src', url);
            })

            $(slideBox).find(".insights-right .js-video-main").css('display','block');
        }

        function showSmallImage (url) {
            $(slideBox).find(".insights-right .js-closed").css('display', 'none');
            $(slideBox).find(".insights-right").css('background-image', 'none');
            $(slideBox).find(".insights-right .js-video-main").css('display','none');

            $(slideBox).find(".insights-right .js-small-main").attr('src', url);
            $(slideBox).find(".insights-right .js-small-main").css('display','block');

        }

        function showBigImage (url) {
            $(slideBox).find(".insights-right .js-closed").css('display', 'none');
            $(slideBox).find(".insights-right .js-video-main").css('display','none');
            $(slideBox).find(".insights-right .js-small-main").css('display','none');

            $(slideBox).find(".insights-right").css('background-image', 'url(' + url + ')');
        }

        function hideAll () {
            $(slideBox).find(".insights-right .js-video-main").css('display','none');
            $(slideBox).find(".insights-right .js-small-main").css('display','none');

            $(slideBox).find(".insights-right").css('background-image', 'none');

            $(slideBox).find(".insights-right .js-closed").css('display', 'block');
        }


    });

    $(".accordion[data-index='1']").each(function(){
        $(this).trigger('click');
    });

    // var arr = $(".accordion[data-index='1']");
    // for (var i = 0; i < arr.length; i++) {
    //     arr.eq(i).trigger('click');
    // }
}


// WEBPACK FOOTER //
// ./assets/js/modules/accordion.js